// extracted by mini-css-extract-plugin
export default {"modal":"SignUpError_modal__xSOay","container":"SignUpError_container__y9cFa","close":"SignUpError_close__lMuv-"};